import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import EquipmentContainer from '../../containers/equipment-container';
import EquipmentItem from '../../containers/equipment-item';

const EquipmentContainerBlock = props => <EquipmentContainer {...props} />;
EquipmentContainerBlock.displayName = 'EquipmentContainer';

export default withDynamicComponents({
  componentWhitelist: [
    EquipmentItem,
  ],
  mapInputToOutput: [
    ['equipmentItem', 'equipmentItem'],
  ],
})(EquipmentContainerBlock);



// WEBPACK FOOTER //
// ./src/blocks/equipment-container/index.jsx